import React from 'react'
import {useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {ErrorBoundary} from 'components/ErrorBoundary'
import {SearchResults} from 'components/SearchResults'
import {getError} from 'modules/search/selectors'

import {cssTheme} from '@vio/atlas/themes'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'

const VerticalFilledSection = styled.div`
  flex: 1 auto;
`

const ContentWrapper = styled.div`
  margin-top: 0;
`

const ErrorElement = styled.div`
  margin-top: 10px;
  padding: ${cssTheme.layout.spacing.s500};
  background: ${cssTheme.colors.background.danger.tertiary};
  color: ${cssTheme.colors.content.danger.secondary};
  border-radius: ${cssTheme.layout.radius.xs};
  font-weight: ${cssTheme.fonts.weight.md};
`

const Search = () => {
  const error = useSelector(getError)

  return (
    <>
      <VerticalFilledSection>
        <ErrorBoundary>
          <ContentWrapper>
            {error ? (
              // This error is never shown, because the ErrorBoundary component already shows an error message higher up in the tree
              <ErrorElement>
                <FormattedMessageWrapper
                  id="searchError"
                  defaultMessage="Search error:"
                />{' '}
                {error}
              </ErrorElement>
            ) : (
              <SearchResults />
            )}
          </ContentWrapper>
        </ErrorBoundary>
      </VerticalFilledSection>
    </>
  )
}

export default Search
